import { format } from 'date-fns';
import { mergePdfFilesByUrls } from './file';

export const exportLabelsPdf = async (labelUrls: string[]): Promise<void> => {
  const datetime = format(new Date(), 'yyyyMMddHHmmss');
  const fileName = `labels-exported-at-${datetime}.pdf`;
  await mergePdfFilesByUrls(labelUrls, fileName);
};
